'use client';
import { useSearchParams } from 'next/navigation';
import { Suspense, useEffect } from 'react';
import { useSafeSearchParamsExtended } from './useSafeSearchParams';

export const SearchParamsObserver = () => {
  return (
    <Suspense fallback={null}>
      <SearchParamsObserverInternal />
    </Suspense>
  );
};

const SearchParamsObserverInternal = () => {
  const searchParams = useSearchParams();
  const searchParamsExtended = useSafeSearchParamsExtended();

  useEffect(() => {
    searchParamsExtended?.setSearchParams(searchParams);
  }, [searchParams, searchParamsExtended]);
  return null;
};
